import { gsap } from 'gsap';
import { containerNames } from '../../constants';
import { PixiBase } from '../../core/pixi/PixiBase';
import { isMobile } from '../../helpers/isMobile';
import {
  updateExpiresBoosted,
  createTextWinAmountAndCurrencySymbol,
} from '../../helpers/boostedHelper';
import { userSettingsStore } from '../../store/userSettingsStore';
import { userInfoStore } from '../../store/userInfoStore';
import { betBarStore } from '../../store/betBarStore';
import { boostedJackpotStore } from '../../store/boostedJackpotStore';
import { gameMainDrawer } from './gameMainDrawer';
import { Spine } from '../../services/elementTypeService/Spine';
import { gameStore } from '../../store/gameStore';
import { spinBarStore } from '../../store/spinBarStore';
import { setTranslationValues } from '../../core/helpers';
import { isoStandard } from '../../helpers/isoStandard';

// eslint-disable-next-line import/named
export class BoostedJackpotDrawer {
  constructor() {
    this.animations = {};
    this.BoostedJackpotContainer = PixiBase.createContainer(containerNames.BoostedJackpotContainer);
    this.BoostedJackpotInitialPopup = PixiBase.createContainer('BoostedJackpotInitialPopup');
    PixiBase.setPosition(this.BoostedJackpotInitialPopup, {
      x: isMobile() ? 22.5 : 341,
      y: isMobile() ? 300 : 148,
    });
    this.BoostedJackpotInitialPopup.scale.set(isMobile() ? 0.65 : 1);
    this.BoostedJackpotIconContainer = PixiBase.createContainer('BoostedJackpotIconContainer');
    this.BoostedJackpotIconContainer.visible = true;
    PixiBase.setPosition(this.BoostedJackpotIconContainer, {
      x: isMobile() ? 480 : 1354,
      y: isMobile() ? 95 : 113,
    });
  }

  setupBoostedJackpotIcon() {
    this.BoostedJackpotIconContainer.visible = true;
    this.wheelIcon = new Spine({ key: 'wheelIcon' });
    this.wheelIcon.play('idle', true);
    this.BoostedJackpotIconContainer.addChild(this.wheelIcon);
    PixiBase.setupButtonMode(this.wheelIcon, {
      interactive: true,
      buttonMode: true,
    });
    PixiBase.registerPointerup(this.wheelIcon, () => {
      if (spinBarStore.isAutoBetStart || spinBarStore.isSpinStart) {
        return;
      }
      spinBarStore.setIsSpinStart(true);
      gameMainDrawer.boostedInfo.BoostedInfoContainer.visible = true;
    });
    this.BoostedJackpotContainer.addChild(this.BoostedJackpotIconContainer);
  }

  updateWheelIconAnimation(animationName) {
    this.wheelIcon.play(animationName, true);
  }

  setupBoostedJackpotIconSliderBoard() {
    this.sliderBoardContainer = PixiBase.createContainer('sliderBoardContainer');
    this.boostedJackpotIconSliderBoardContainer = PixiBase.createContainer(
      'boostedJackpotIconSliderBoardContainer'
    );
    PixiBase.setPosition(this.boostedJackpotIconSliderBoardContainer, {
      x: isMobile() ? 100 : 100,
      y: isMobile() ? 0 : 0,
    });
    this.sliderBoard = PixiBase.createSprite(this.spriteSheet.boostedJackpotIconInfoBoardRectangle);
    this.sliderBoard.anchor.set(0.5);
    const graphics = PixiBase.createGraphics();
    const mask = PixiBase.setMaskGraphicProperties(graphics, [
      isMobile() ? -330 : -320,
      isMobile() ? -22 : -22,
      this.spriteSheet.boostedJackpotIconInfoBoardRectangle.width,
      this.spriteSheet.boostedJackpotIconInfoBoardRectangle.height,
    ]);
    this.slotBarReelsContainer = PixiBase.setMaskGraphicToContainer(
      this.boostedJackpotIconSliderBoardContainer,
      mask
    );

    this.boostedJackpotIconSliderBoardContainer.addChild(graphics);
    this.sliderBoardContainer.addChild(this.sliderBoard);
    this.boostedJackpotIconSliderBoardContainer.addChild(this.sliderBoardContainer);
    this.BoostedJackpotIconContainer.addChild(this.boostedJackpotIconSliderBoardContainer);
    this.BoostedJackpotContainer.addChild(this.BoostedJackpotIconContainer);
  }

  setupBoostedJackpotIconSliderBoardDailyDropsText() {
    this.playerBoostedWinAmountText = PixiBase.createText(
      gameStore.canvasTranslationKeys.DAILY_AWARDS_TITLE,
      {
        fontSize: 14,
        fill: '#FFC33E',
        align: 'center',
        fontWeight: 700,
        fontFamily: 'Poppins',
        _wordWrap: true,
        _wordWrapWidth: 206,
      }
    );
    this.playerBoostedWinAmountText.anchor.set(0.5);
    this.playerBoostedWinAmountText.y = -15;
    this.playerBoostedWinAmount = createTextWinAmountAndCurrencySymbol({
      x: -20,
      y: 11,
      color: '#FFFFFF',
      amount: 0,
      margin: 30,
      fontSize: 16,
      name: 'playerBoostedWinAmount',
    });
    this.sliderBoardContainer.addChild(
      this.playerBoostedWinAmountText,
      this.playerBoostedWinAmount
    );
    this.boostedJackpotIconSliderBoardContainer.addChild(this.sliderBoardContainer);
  }

  startGsapSliderAnimation(winAmount) {
    this.playerBoostedWinAmount.children[0].text = isoStandard(winAmount || 0);
    this.playerBoostedWinAmount.children[1].x =
      this.playerBoostedWinAmount.children[0].x +
      this.playerBoostedWinAmount.children[0].width / 2 +
      20;
    this.playerBoostedWinAmount.children[1].text = userInfoStore.currencySymbol;
    gsap.to(this.sliderBoardContainer, {
      x: -210,
      duration: 1,
      ease: 'none',
      onComplete: () => {
        setTimeout(() => {
          gsap.to(this.sliderBoardContainer, {
            x: 0,
            duration: 1,
            ease: 'none',
          });
        }, 3000);
      },
    });
  }

  setupBoostedJackpotIconBoard() {
    const wheelIconBoardContainer = PixiBase.createContainer('BoostedJackpotIconContainer');
    wheelIconBoardContainer.y = 30;

    this.wheelIconBoard = PixiBase.createSprite(this.spriteSheet.boostedJackpotIconInfoBoard);
    this.wheelIconBoard.anchor.set(0.5);
    wheelIconBoardContainer.addChild(this.wheelIconBoard);
    this.BoostedJackpotIconContainer.addChild(wheelIconBoardContainer);
  }

  setupBoostedJackpotPopup() {
    const BackgroundContainer = PixiBase.createContainer('BackgroundContainer');
    const popupSprite = PixiBase.createSprite(this.spriteSheet.boostedJackpotInitialPopup);
    const popupCloseButton = PixiBase.createSprite(this.spriteSheet.boostedJackpotPopupCloseButton);
    if (isMobile()) {
      popupCloseButton.scale.set(1.5);
    }
    popupCloseButton.x = popupSprite.width - (isMobile() ? 60 : 50);
    PixiBase.setupButtonMode(popupCloseButton, {
      interactive: true,
      buttonMode: true,
    });
    PixiBase.registerPointerup(popupCloseButton, () => {
      this.handleInitialPopupButtonClick(false);
    });
    BackgroundContainer.addChild(popupSprite, popupCloseButton);
    this.BoostedJackpotInitialPopup.addChild(BackgroundContainer);
  }

  setupBoostedJackpotOkButton() {
    const { isBoostedJackpotInitialPopup } = userSettingsStore;

    const OkButtonContainer = PixiBase.createContainer('OkButtonContainer');
    const button = PixiBase.createSprite(this.spriteSheet.boostedJackpotInfoPopupOkButton);
    const text = PixiBase.createText(gameStore.canvasTranslationKeys.OK, {
      fontSize: 30,
      fill: '#F5F7FC',
      align: 'center',
      fontWeight: 700,
      fontFamily: 'Poppins',
    });
    text.anchor.set(0.5);
    PixiBase.setPosition(button, { x: 278, y: 400 });
    PixiBase.setPosition(text, { x: 375, y: 435 });
    OkButtonContainer.y = 25;
    OkButtonContainer.addChild(button, text);
    this.BoostedJackpotInitialPopup.addChild(OkButtonContainer);
    this.BoostedJackpotInitialPopup.visible = isBoostedJackpotInitialPopup;

    PixiBase.setupButtonMode(OkButtonContainer, {
      interactive: true,
      buttonMode: true,
    });
    PixiBase.registerPointerup(OkButtonContainer, () => {
      this.handleInitialPopupButtonClick(true);
      gameMainDrawer.boostedJackpot.updateWheelIconAnimation('active');
    });
  }

  handleInitialPopupButtonClick(isSelectedAmount) {
    const { updateIsBoostedJackpotInitialPopup } = userSettingsStore;
    const { boostedBetAmount } = boostedJackpotStore;
    if (isSelectedAmount) {
      betBarStore.setSelectedAmount(boostedBetAmount);
      gameMainDrawer.betBar.updateQuickBets();
    }
    updateIsBoostedJackpotInitialPopup(false);
    this.BoostedJackpotInitialPopup.visible = false;
    this.graphics.visible = false;
  }

  setupInitialPrizePoolAmount() {
    const PrizePoolAmountContainer = createTextWinAmountAndCurrencySymbol({
      x: 320,
      y: 119,
      margin: 65,
      fontSize: 54,
      color: '#F5F7FC',
      amount: boostedJackpotStore.prizePoolAmount,
      name: 'PrizePoolAmountContainer',
    });
    this.BoostedJackpotInitialPopup.addChild(PrizePoolAmountContainer);
    this.BoostedJackpotContainer.addChild(this.BoostedJackpotInitialPopup);
  }

  setupInitialWinningCount() {
    const styles = { fontWeight: 700, fontFamily: 'Arial', align: 'center' };
    const winningCountContainer = PixiBase.createContainer('BoostedJackpotWinningCount');
    const winningCount = PixiBase.createText(gameStore.canvasTranslationKeys.WINNING_COUNT, {
      ...styles,
      fontSize: 20,
      fill: '#F5F7FC',
      wordWrap: true,
      wordWrapWidth: 206,
    });
    const winningCountUpTo = PixiBase.createText(`${boostedJackpotStore.winningCount}+`, {
      ...styles,
      fontSize: 30,
      fill: '#FFC33E',
    });
    winningCount.anchor.set(0.5);
    winningCountUpTo.anchor.set(0.5);
    PixiBase.setPosition(winningCountContainer, { x: 280, y: 180 });
    PixiBase.setPosition(winningCount, { x: 100, y: 0 });
    PixiBase.setPosition(winningCountUpTo, { x: 100, y: 35 });
    winningCountContainer.addChild(winningCount, winningCountUpTo);
    this.BoostedJackpotInitialPopup.addChild(winningCountContainer);
  }

  setupInitialPopupBetText() {
    const initialPopupBetTextContainer = PixiBase.createContainer('initialPopupBetTextContainer');
    PixiBase.setPosition(initialPopupBetTextContainer, { x: 378, y: 386 });
    const text = PixiBase.createText(
      setTranslationValues(`${gameStore.canvasTranslationKeys.POP_UP_TEXT}`, {
        VALUE: `${isoStandard(betBarStore.limits.boostedJackpotBetAmount)} ${
          userInfoStore.currencySymbol
        }`,
      }),
      {
        fontSize: 14,
        fontWeight: 400,
        fontFamily: 'Arial',
        fill: '#FFFFFF',
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 500,
      }
    );
    text.anchor.set(0.5);
    initialPopupBetTextContainer.addChild(text);
    this.BoostedJackpotInitialPopup.addChild(initialPopupBetTextContainer);
  }

  setupBoostedJackpotPopupDate({ x, y, isIcon = false, styles, marginX, parent }) {
    const BoostedJackpotPopupDateContainer = PixiBase.createContainer(
      'BoostedJackpotPopupDateContainer'
    );
    this.dateTimeHeader.forEach((_, index) => {
      const text = PixiBase.createText('', styles);
      BoostedJackpotPopupDateContainer.addChild(text);
      text.x = index * marginX;
    });
    updateExpiresBoosted(BoostedJackpotPopupDateContainer, this.iconJackpotPopupDateHeader, isIcon);
    PixiBase.setPosition(BoostedJackpotPopupDateContainer, { x: x, y: y });
    parent.addChild(BoostedJackpotPopupDateContainer);
  }

  setupBoostedJackpotDateHeader({ x, y, styles, marginX, parent }) {
    const { DAYS, HOURS, MINUTES, SECONDS } = gameStore.canvasTranslationKeys;
    const BoostedJackpotPopupDateHeaderContainer = PixiBase.createContainer(
      'BoostedJackpotPopupDateHeaderContainer'
    );
    PixiBase.setPosition(BoostedJackpotPopupDateHeaderContainer, { x: x, y: y });
    this.dateTimeHeader = [DAYS, HOURS, MINUTES, SECONDS];
    this.dateTimeHeader.forEach((title, index) => {
      const text = PixiBase.createText(title, styles);
      BoostedJackpotPopupDateHeaderContainer.addChild(text);
      text.x = index * marginX;
    });
    parent.addChild(BoostedJackpotPopupDateHeaderContainer);
    return BoostedJackpotPopupDateHeaderContainer;
  }

  createGraphicsForBoostedJackpot() {
    const { isBoostedJackpotInitialPopup } = userSettingsStore;
    const graphics = PixiBase.createGraphics();
    this.graphics = graphics;
    graphics.beginFill('black');
    graphics.alpha = 0.7;
    graphics.interactive = true;
    graphics.drawRect(0, 0, isMobile() ? 540 : 1440, isMobile() ? 960 : 810);
    graphics.endFill();
    graphics.visible = isBoostedJackpotInitialPopup;
    this.BoostedJackpotContainer.addChild(this.graphics);
  }

  executeBoostedJackpotInitialPopup() {
    const styles = { fontWeight: 700, fill: '#FFFFFF', align: 'center', fontFamily: 'Arial' };
    this.createGraphicsForBoostedJackpot();
    this.setupBoostedJackpotPopup();
    this.setupInitialPrizePoolAmount();
    this.setupInitialWinningCount();
    this.setupBoostedJackpotOkButton();
    this.setupInitialPopupBetText();
    this.initialJackpotPopupDateHeader = this.setupBoostedJackpotDateHeader({
      x: 200,
      y: 336,
      marginX: 105,
      parent: this.BoostedJackpotInitialPopup,
      styles: { ...styles, fontSize: 15 },
    });
    this.setupBoostedJackpotPopupDate({
      x: 176,
      y: 277,
      marginX: 111,
      parent: this.BoostedJackpotInitialPopup,
      styles: { ...styles, fontSize: 50, letterSpacing: 19 },
    });
  }

  executeBoostedJackpotIcon() {
    const styles = { fontWeight: 600, align: 'center', fontFamily: 'Arial' };
    this.setupBoostedJackpotIconSliderBoard();
    this.setupBoostedJackpotIconSliderBoardDailyDropsText();
    this.setupBoostedJackpotIcon();
    this.setupBoostedJackpotIconBoard();
    this.iconJackpotPopupDateHeader = this.setupBoostedJackpotDateHeader({
      x: -18,
      y: 35,
      marginX: 25,
      parent: this.BoostedJackpotIconContainer,
      styles: { ...styles, fontSize: 8, fill: '#FFFFFF' },
    });
    this.setupBoostedJackpotPopupDate({
      x: -20,
      y: 18,
      marginX: 25,
      isIcon: true,
      parent: this.BoostedJackpotIconContainer,
      styles: { ...styles, fontSize: 14, fill: '#FFC33E' },
    });
  }

  execute(config, spriteSheet) {
    const [gameImageSpriteSheet] = spriteSheet;
    this.config = config;
    this.spriteSheet = gameImageSpriteSheet;
  }
}
